import React, { useState } from "react";
import {
  mediaFaqCategories,
  mediaFaqItems,
  MediaFaqCategory,
} from "./media-faq-data";
import {
  PROPERTY_FEATURED_FORM_ID,
  scrollToPropertyFeaturedForm,
} from "./scroll-to-featured-form";
import "./styles.css";

const MediaFaqSection = () => {
  const [activeCategory, setActiveCategory] =
    useState<MediaFaqCategory>("getting-started");
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  const items = mediaFaqItems[activeCategory];

  const handleCategoryChange = (category: MediaFaqCategory) => {
    setActiveCategory(category);
    setOpenItemId(null);
  };

  const toggleItem = (id: string) => {
    setOpenItemId((current) => (current === id ? null : id));
  };

  return (
    <section className="media-faq">
      <div className="container mx-auto max-w-7xl">
        <div className="faq-container">
          <p className="media-faq-label">FAQ</p>
          <h2 className="media-faq-title">Frequently Asked Questions</h2>

          <div
            className="media-faq-tabs"
            role="tablist"
            aria-label="FAQ categories"
          >
            {mediaFaqCategories.map((category) => (
              <button
                key={category.id}
                type="button"
                role="tab"
                aria-selected={activeCategory === category.id}
                className={`media-faq-tab ${
                  activeCategory === category.id ? "active" : ""
                }`}
                onClick={() => handleCategoryChange(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>

          <div className="media-faq-list">
            {items.map((item) => {
              const isOpen = openItemId === item.id;

              return (
                <div
                  key={item.id}
                  className={`media-faq-item ${isOpen ? "open" : ""}`}
                >
                  <button
                    type="button"
                    className="media-faq-question"
                    aria-expanded={isOpen}
                    onClick={() => toggleItem(item.id)}
                  >
                    <span>{item.question}</span>
                    <i className="fa-solid fa-chevron-down" />
                  </button>
                  {isOpen && (
                    <div className="media-faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="media-faq-cta">
            <p>Still have questions? We&apos;re happy to help.</p>
            <div className="media-faq-cta-actions">
              <a href="tel:09118008008" className="media-faq-call-btn">
                <i className="fa-solid fa-phone" />
                Call 09118008008
              </a>
              <a
                href={`#${PROPERTY_FEATURED_FORM_ID}`}
                className="media-faq-submit-btn"
                onClick={scrollToPropertyFeaturedForm}
              >
                Submit Your Property
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaFaqSection;
